import { apiClientV1 } from './apiClient';

export default {
  createPlaylist: (params) => apiClientV1.post('/video/playlist', { ...params }),
  updatePlaylist: (playlistId, params) => apiClientV1.put(`/video/playlists/${playlistId}`, { ...params }),
  deletePlaylist: (playlistId) => apiClientV1.delete(`/video/playlist/${playlistId}/archive`),
  copyPlaylist: (id) => apiClientV1.post(`/video/playlists/${id}/copy`),
  getPlaylistStats: (playlistId, params) => apiClientV1.get(`/video/playlists/${playlistId}/breakdown`, { params }),
  getPlaylist: (playlistId) => apiClientV1.get(`/video/playlists/${playlistId}`),
  getPlaylistPreview: (playlistId) => apiClientV1.get(`/video/playlists/${playlistId}/preview`),
  getPlaylistStatistic: (playlistId) => apiClientV1.get(`/video/playlists/${playlistId}/statistic`),
  getRecipientsByPackage: (playlistId, params) => apiClientV1.post(`/video/playlist/${playlistId}/links`, { ...params }),
  getPlaylistsList: (params) => apiClientV1.get('/video/playlists', { params }),
  getAttachments: (playlistId) => apiClientV1.get(`/video/playlists/${playlistId}/attachments`),
  addVideoToPlaylist: (params) => apiClientV1.put(`/video/${params.videoId}/playlists/${params.playlistId}`, {}, { silentErrorNotification: true }),
  addMultipleVideosToPlaylist: (playlistId, params) => apiClientV1.put(`/video/playlists/${playlistId}/videos`, { ...params }, { silentErrorNotification: true })
};
